module.exports = __webpack_public_path__ + "static/media/staffTable.c29868a1.jpg";